const StatCardSkeleton = () => (
  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-5">
    <div className="flex justify-between items-start">
      <div className="flex-1">
        <div className="h-4 w-28 bg-gray-200 animate-pulse rounded" />
        <div className="h-8 w-24 bg-gray-200 animate-pulse rounded mt-2" />
      </div>
      <div className="h-9 w-9 bg-gray-200 animate-pulse rounded-lg" />
    </div>
  </div>
);

export default StatCardSkeleton;
